module.exports = __webpack_public_path__ + "img/product_bg_1.49e555cc.jpg";